export const getGraphIdFromURL = () => {
    const pageType = window.location?.pathname.split('/')[1];
    const recordID = window.location?.pathname.split('/')[3];
    let graphID = '';

    switch (pageType) {
        case 'member':
            graphID = Buffer.from(`01:Member${recordID}`).toString('base64');
            break;

        case 'company':
            graphID = Buffer.from(`01:Company${recordID}`).toString('base64');
            break;

        default:
            graphID = null;
            break;
    }

    return graphID;
};
